<template>
  <div class="concept-stream">
    <div class="concepts">
      <p v-if="showGroupError" style="text-align: center;">Please go directly to your group's URL.</p>
      <p v-if="$store.state.org.concepts.length == 0 && !showGroupError && !$store.state.org.fetchedConcepts" style="text-align: center;">Fetching concepts...</p>
      <p v-if="$store.state.org.concepts.length == 0 && $store.state.org.fetchedConcepts" style="text-align: center;">Create a concept to start sorting!</p>
      <ConceptCard
        v-for="(concept, index) in $store.state.org.concepts"
        v-bind:concept="concept"
        v-bind:index="index"
        v-bind:key="concept.id"
        v-bind:currentPosition="currentPosition"
        @scrolled="addToScroll"
        @goToConcept="goToConcept(concept)"
        @scrollToConcept="scrollToConcept({ id: concept.id })"
      ></ConceptCard>
    </div>
    <div class="scroll-area" ref="scroller">
      <div class="carousel">
        <div class="begin"></div>
        <div class="planes">
          <div class="plane" v-for="(concept, index) in $store.state.org.concepts" v-bind:key="index" :id="'plane-' + concept.id">
          </div>
        </div>
        <div class="end"></div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import ConceptCard from '@trust/components/ConceptCard.vue'

export default {
  name: 'ConceptStream',
  components: {
    ConceptCard,
  },
  data() {
      return {
        scrollAmount: 0,
        debounceAmount: 1,
      }
  },
  props: ['showGroupError'],
  activated() {
    this.$refs.scroller.scrollTop = this.scrollAmount;
  },
  computed: {
    planeHeight(){
      if(document.getElementsByClassName('plane').length > 0) {
        return document.getElementsByClassName('plane')[0].clientHeight;
      } else {
        return (window.innerHeight - 44 - 20 - 4) / 2;
      }
    },
    currentPosition() {
      let planeHeight = this.planeHeight;
      let scrollPoint = this.scrollAmount + planeHeight; // set scrollPoint at middle
      let pos = Math.floor(scrollPoint / planeHeight);
      return pos - 1; // to start at 0
    },
  },
  mounted() {
    this.handleDebouncedScroll = debounce(this.handleScroll, this.debounceAmount);
    this.$refs.scroller.addEventListener('scroll', this.handleDebouncedScroll);
  },
  beforeDestroy() {
    this.$refs.scroller.removeEventListener('scroll', this.handleDebouncedScroll);
  },
  methods: {
    scrollToConcept({ id }){
      let conceptPlaneEls = this.$el.querySelectorAll('.plane');
      conceptPlaneEls.forEach(el => {
        if(el.id == 'plane-' + id) {
          let scrollToPoint = el.offsetTop - this.planeHeight + 4;
          // console.log('scrollToConcept planeHeight', this.planeHeight)
          // console.log('scrollToConcept', scrollToPoint)
          let scrollAreaEl = this.$refs.scroller;
          scrollAreaEl.scrollTo(0, scrollToPoint);
        }
      })

    },
    handleScroll() {
      this.scrollAmount = this.$refs.scroller.scrollTop;
      this.$store.commit('setConceptsCurrentPosition', { pos: this.currentPosition });
    },
    addToScroll({ event }) {
      this.$refs.scroller.scrollTop = this.$refs.scroller.scrollTop + event.deltaY;
    },
    goToConcept(concept){
      if(this.$store.state.trust.canEdit || this.$store.state.trust.isEditing) {
        return;
      }
      let slug = encodeURIComponent(concept.name.toLowerCase());
      // this.$router.push('/' + slug);
      // this.$store.dispatch('goToConcept', slug)
      this.$store.dispatch('routing/goToConcept', { slug }, {root: true});
    }
  },
  watch: {
    '$store.state.stations.concepts.scrollToConceptId' (to) {
      if(to != ''){
        this.scrollToConcept({ id: to });
      }
    },
    '$store.state.stations.concepts.scrollNavEvent' (to) {
      if(to){
        this.addToScroll({ event: to });
      }
    }
  }
}

</script>
